import './App.scss';
import './index.scss';

import { Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

import CircularProgress from '@material-ui/core/CircularProgress';
import { map } from 'lodash-es';
import { Provider } from 'react-redux';
import store from './Redux/store';
import {
  commonRouteMap,
  privateRouteMap,
  publicRouteMap,
  customerRouteMap,
  adminRouteMap,
  fraudprivateRouteMap
} from './routes';
import PrivateRoute from './routes/PrivateRoute';
import PublicRoute from './routes/PublicRoute';
import CommonRoute from './routes/CommonRoute';
import AdminRoute from './routes/AdminRoute';
import CustomerRoute from 'routes/CustomerRoute';
// import { app } from './firebaseConfig';
import FraudprivateRoute from 'routes/FraudRoute';
import TermsGuard from 'shared/guards/TermsGuard';

type Props = {};

const App = (props: Props) => {
  // useEffect(() => {
  //   if ('serviceWorker' in navigator) {
  //     window.addEventListener('load', () => {
  //       navigator.serviceWorker
  //         .register('/firebase-messaging-sw.js')
  //         .then((registration) => {})
  //         .catch((error) => {
  //           console.error('Service Worker registration failed:', error);
  //         });
  //     });
  //   }
  // }, []);

  return (
    <Provider store={store}>
      <Router>
        <Suspense
          fallback={
            <CircularProgress
              className="loading"
              disableShrink
              color="inherit"
            />
          }
        >
          <Switch>

            {/* ✅ Fix: use route.path as key — guaranteed unique per route */}
            {map(commonRouteMap, (route) => (
              <CommonRoute
                key={`common-${route.path}`}
                exact
                path={route.path}
                component={route.component}
              />
            ))}

            {map(publicRouteMap, (route) => (
              <PublicRoute
                key={`public-${route.path}`}
                exact
                path={route.path}
                component={route.component}
              />
            ))}

            <TermsGuard>

              {map(customerRouteMap, (route) => (
                <CustomerRoute
                  key={`customer-${route.path}`}
                  exact
                  path={route.path}
                  component={route.component}
                />
              ))}

              {map(privateRouteMap, (route) => (
                <PrivateRoute
                  key={`private-${route.path}`}
                  exact
                  path={route.path}
                  component={route.component}
                />
              ))}

              {map(adminRouteMap, (route) => (
                <AdminRoute
                  key={`admin-${route.path}`}
                  exact
                  path={route.path}
                  component={route.component}
                />
              ))}

              {map(fraudprivateRouteMap, (route) => (
                <FraudprivateRoute
                  key={`fraud-${route.path}`}
                  exact
                  path={route.path}
                  component={route.component}
                />
              ))}

            </TermsGuard>

          </Switch>
        </Suspense>
      </Router>
    </Provider>
  );
};

export default App;